import React from 'react';
import './DeleteConfirmModal.css';

/**
 * DeleteConfirmModal - Simple confirmation modal for soft delete operations
 * 
 * Unlike hard delete, soft delete is reversible, so we use a simpler confirmation
 * without the 3-digit code requirement.
 */
function DeleteConfirmModal({
  show,
  onClose,
  onConfirm,
  itemType = 'item',
  itemCount = 1,
  itemNames = [],
  isBulk = false,
}) {
  if (!show) return null;

  const getTitle = () => {
    if (isBulk) {
      return `Delete ${itemCount} ${itemType}${itemCount > 1 ? 's' : ''}?`;
    }
    return `Delete ${itemType}?`;
  };

  const getMessage = () => {
    if (isBulk) {
      return (
        <>
          <p>
            You are about to delete <strong>{itemCount} {itemType}{itemCount > 1 ? 's' : ''}</strong>.
          </p>
          <p className="restore-hint">
            This action uses soft delete. You can restore deleted items later.
          </p>
        </>
      );
    }
    
    const name = itemNames?.[0] || 'this item';
    return (
      <>
        <p>
          Are you sure you want to delete <strong>{name}</strong>?
        </p>
        <p className="restore-hint">
          This action uses soft delete. You can restore it later.
        </p>
      </>
    );
  };

  return (
    <div className="delete-confirm-overlay" onClick={onClose}>
      <div className="delete-confirm-modal" onClick={(e) => e.stopPropagation()}>
        <div className="delete-confirm-header">
          <h3>{getTitle()}</h3>
          <button className="delete-confirm-close" onClick={onClose}>×</button>
        </div>
        
        <div className="delete-confirm-body">
          {getMessage()}
          
          {isBulk && itemNames && itemNames.length > 0 && itemNames.length <= 5 && (
            <ul className="delete-item-list">
              {itemNames.map((name, idx) => (
                <li key={idx}>{name}</li>
              ))}
              {itemCount > itemNames.length && (
                <li className="more-items">...and {itemCount - itemNames.length} more</li>
              )}
            </ul>
          )}
        </div>
        
        <div className="delete-confirm-footer">
          <button 
            type="button"
            className="btn-cancel"
            onClick={onClose}
          >
            Cancel
          </button>
          <button 
            type="button"
            className="btn-delete"
            onClick={onConfirm}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteConfirmModal;
